import API from '../../../../services/apiService.js'

var api= new API();


export default {

    // Загрузить опубликованные акции
    async loadPublishedStocks({commit}) {
        var data = null;
        try {
            data = await api.Get("InformationService/Stock/GetPublished");
            commit('loadPublished', data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    // Загрузить акции в ожидании одобрения
    async loadActiveStocks({commit}) {
        var data = null;
        try {
            data = await api.Get("InformationService/Stock/GetAwait");
            commit('loadActive', data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //добавить
    async addStock({commit}, data) {
        var newData = null;
        var newId = null;
        try {
            newId = await api.Post("InformationService/Stock", data);
            if (newId != null) {
                var getparams = '?Id=' + newId.id;
                newData = await api.Get("InformationService/Stock/GetById" + getparams)
            }
            if (newData != null && newData != "")
                commit('addStock', newData);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //редактировать
    async editStock({commit}, data) {
        try {
            await api.Put("InformationService/Stock", data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //удалить
    async deleteStock({commit}, stockId) {
        try {
            var getparams = '?StockId=' + stockId;
            await api.Delete("InformationService/Stock", getparams);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //принять акцию
    async acceptStock({commit}, stockId) {
        try {
          let params=`?stockId=${stockId}`
           await api.Put("InformationService/Stock/AcceptStock"+params);

        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //отклонить акцию
    async rejectStock({commit}, data) {
        try {
            let params=`?stockId=${data.stockId}&Comment=${data.comment}`
            await api.Put("InformationService/Stock/RejectStock"+params);

        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //получить список партнеров
    async getOrgItems({commit}){
        var data = null;
        try {
            data = await api.Get("OrganizationService/Organization");
            commit('setOrgItems', data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //отправить на одобрение
    async sendToReview({commit}, stockId){
        var data = null;
        try {
            let params=`?stockId=${stockId}`
            data = await api.Put("InformationService/Stock/SendToReview"+params);
            commit('setOrgItems', data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    }
}
